import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import { getSchedule, putSchedule } from "../hooks/Schedule";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { COLORS } from "./constants";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function SchedulePage({ user }) {
  const [users, setUsers] = useState([]);
  const [myDays, setMyDays] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [calendar, setCalendar] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState("All");
  const [myOffice, setMyOffice] = useState("");

  useEffect(() => {
    (async () => {
      const response = await fetch(
        `${process.env.REACT_APP_DB_URL}/user_office/${user}`
      );
      const res = await response.json();
      // console.log('office: ', res[0].office)
      setMyOffice(res[0].office);
      setSelectedOffice(res[0].office);
    })();

    refresh();
  }, []);

  const refresh = async () => {
    const res = await getSchedule();
    console.log("refresh: ", res);
    setUsers(res.users);
    setCalendar(res.calendar);
    const me = res.users.filter((u) => u.name === user)[0];
    setMyDays(me.mydays);
    setSchedule(me.schedule);
  };

  const handleClick = (event) => {
    const id = Number(event.currentTarget.id);
    const newSche = [...schedule];
    newSche[id] = newSche[id] === "1" ? "0" : "1";
    setSchedule(() => newSche);
    console.log(id, newSche);
  };
  const handleClickMyDays = (event) => {
    const id = Number(event.currentTarget.id);
    let newMydays = [...myDays];
    newMydays[id] = newMydays[id] === "1" ? "0" : "1";
    setMyDays(newMydays);

    newMydays = newMydays.join("");
    console.log(id, newMydays);
    console.log(schedule);
    console.log("todayIndex: ", todayIndex);
    const todayDayOfWeek = new Date().getDay() - 1; // start Monday
    console.log("todayDayOfWeek: ", todayDayOfWeek);
    console.log("schedule.length: ", schedule.length);
    let newSche = schedule.join("");
    console.log("newSche: ", newSche);

    let buf = newSche.slice(
      0,
      todayIndex - (todayDayOfWeek >= 0 && todayDayOfWeek < 5 ? 1 : 2)
    );
    buf += newMydays.slice(todayDayOfWeek, 5);
    do {
      buf += newMydays;
    } while (buf.length < schedule.length);
    buf = buf.slice(0, schedule.length);

    console.log("buf: ", buf, buf.length);
    setSchedule(() => [...buf]);
  };

  const handleChange = (event) => {
    setSelectedOffice(event.target.value);
  };

  const handleSave = async () => {
    // const myDaysCount = myDays.filter((d) => d === "1").length;
    // if (myDaysCount < process.env.REACT_APP_MIN_OFFICE_DAYS) {
    //   alert(`Select at least ${process.env.REACT_APP_MIN_OFFICE_DAYS} days.`);
    //   return;
    // }

    // console.log(myDays.join(""), myDaysCount);
    // console.log(schedule, schedule.join(""));
    putSchedule(user, myDays.join(""), schedule.join(""));

    // await refresh();
  };

  let todayIndex = 0; // today's sequential index in calendar weeks
  const dayHeader = () => {
    const today = new Date();
    let foundToday = false;
    let year = today.getFullYear();
    let month = today.getMonth() + 1;
    let previous_day = 0;

    //------------------------------------------
    // For test
    //------------------------------------------
    // calendar.today = 1

    if (!calendar.weeks) return null;

    let dayOfWeek = [];
    const days = ["M", "T", "W", "TH", "F"]

    const ret = calendar.weeks.map((week, i) => {
      return week.map((d, i2) => {
        // 2nd month
        if (previous_day > d) {
          if (month === 12) {
            month = 1;
            year++;
          } else month++;
        }
        previous_day = d;

        const holiday = calendar.holidays.filter(
          (h) => h.year === year && h.month === month && h.day === d
        );
        let sxObj = {};
        if (!foundToday) {
          todayIndex++;
          if (d >= calendar.today) {
            foundToday = true;
            if (d === calendar.today) {
              sxObj = {
                background: "#1565C0",
                color: "white",
              };
            }
          }
        }
        if (holiday.length > 0) {
          sxObj = {
            ...sxObj,
            background: "#EC7063",
            color: "white",
          };
        }
        console.log(week, foundToday, i, i2, i2 + 5 - week.length);
        const day = days[i === 0 ? i2 + 5 - week.length : i2];

        dayOfWeek.push(<Tds sx={{ fontSize: "0.5rem" }}>{day}</Tds>);
        return <Tds sx={{ ...sxObj, fontWeight: "bold" }}>{d}</Tds>;
      });
    });

    return (
      <>
        <tr>{ret}</tr>
        <tr>{dayOfWeek}</tr>
      </>
    );
  };

  let idx = 0; //sequential index in calendar weeks
  let total = [];
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            // margin: "10px",
            alignItems: "center",
            // justifyContent: "space-between",
            columnGap: "50px",
          }}
        >
          {myDays.length > 0 ? (
            (myOffice === selectedOffice || selectedOffice === "All") && (
              <>
                <Table>
                  <tbody>
                    <tr>
                      {["Mon", "Tue", "Wed", "Thu", "Fri"].map((d) => {
                        return (
                          <Tds sx={{ width: "40px", fontWeight: "bold" }}>
                            {d}
                          </Tds>
                        );
                      })}
                    </tr>
                    <tr>
                      {myDays.map((d, i) => {
                        return (
                          <Tdu>
                            <div
                              style={{ height: "16px", cursor: "pointer" }}
                              id={i}
                              onClick={handleClickMyDays}
                            >
                              {myDays[i] === "1" ? "O" : ""}
                            </div>
                          </Tdu>
                        );
                      })}
                    </tr>
                  </tbody>
                </Table>
                <Button
                  onClick={handleSave}
                  variant="outlined"
                  sx={{ marginTop: "10px" }}
                >
                  Save
                </Button>
              </>
            )
          ) : (
            <Box
              sx={{
                height: "50vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          )}
        </div>
        {calendar.week_length && (
          <Table>
            <thead>
              <tr>
                <Tds rowSpan={3} colSpan={2} sx={{ width: "130px" }}>
                  <FormControl size="small" sx={{ minWidth: "100px" }}>
                    <div>
                      <b>Office</b>
                      {/* <InputLabel id="demo-simple-select-label">
                      Office
                    </InputLabel> */}
                      <Select
                        variant="standard"
                        disableUnderline
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedOffice}
                        label="Office"
                        onChange={handleChange}
                        sx={{ marginLeft: "5px", width: "50px" }}
                      >
                        <MenuItem value={"NY"}>NY</MenuItem>
                        <MenuItem value={"TX"}>TX</MenuItem>
                        <MenuItem value={"CA"}>CA</MenuItem>
                        <MenuItem value={"All"}>All</MenuItem>
                      </Select>
                    </div>
                  </FormControl>
                </Tds>
                <Tds
                  colSpan={calendar.week_length[0]}
                  sx={{ fontWeight: "bold" }}
                >
                  {calendar.month_names[0]}
                </Tds>
                <Tds
                  colSpan={calendar.week_length[1]}
                  sx={{ fontWeight: "bold" }}
                >
                  {calendar.month_names[1]}
                </Tds>
              </tr>

              {dayHeader()}
            </thead>
            <tbody>
              {users
                .filter((u) => {
                  return selectedOffice === "All"
                    ? true
                    : u.office === selectedOffice;
                })
                .map((c) => {
                  return (
                    <>
                      <tr>
                        {(idx = 0) || null}
                        {c.name === user ? (
                          <Tdnu sx={{ fontWeight: "bold" }}>{c.name}</Tdnu>
                        ) : (
                          <Tdn sx={{ width: "130px" }}>{c.name}</Tdn>
                        )}
                        {c.name === user ? (
                          <Tdnu>{c.office}</Tdnu>
                        ) : (
                          <Tdn s>{c.office}</Tdn>
                        )}
                        {calendar.weeks &&
                          calendar.weeks.map((week, i) => {
                            return week.map((d) => {
                              if (c.name === user) {
                                if (idx < todayIndex - 1) {
                                  return (
                                    <Tdu>
                                      <div
                                        style={{
                                          height: "16px",
                                        }}
                                        id={idx}
                                      >
                                        {schedule[idx++] === "1" ? "O" : ""}
                                      </div>
                                    </Tdu>
                                  );
                                }
                                return (
                                  <Tdu>
                                    <div
                                      style={{
                                        height: "16px",
                                        cursor: "pointer",
                                      }}
                                      id={idx}
                                      onClick={handleClick}
                                    >
                                      {schedule[idx++] === "1" ? "O" : ""}
                                    </div>
                                  </Tdu>
                                );
                              } else
                                return i % 2 ? (
                                  <Td>
                                    {c.schedule[idx++] === "1" ? "O" : ""}
                                  </Td>
                                ) : (
                                  <Tdd>
                                    {c.schedule[idx++] === "1" ? "O" : ""}
                                  </Tdd>
                                );
                            });
                          })}
                      </tr>
                    </>
                  );
                })}
              {users
                .filter((u) => {
                  return selectedOffice === "All"
                    ? true
                    : u.office === selectedOffice;
                })
                .reduce((p, c) => {
                  if (total.length === 0) {
                    total = c.schedule.map((s, idx) => {
                      return Number(p.schedule[idx]) + Number(s);
                    });
                  } else {
                    total = c.schedule.map((s, idx) => {
                      return total[idx] + Number(s);
                    });
                  }
                })}
              {/* {console.log("total: ", total) && null} */}
              <tr>
                <Tds colSpan={2}>Total</Tds>
                {total.map((t) => {
                  return <Tds>{t}</Tds>;
                })}
              </tr>
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
}

// schedule
const Tds = styled("td")({
  border: "1px solid darkgray",
  // width: "40px",
  fontSize: "0.7rem",
  textAlign: "center",
  background: COLORS.GRID_HEADER_BACKGROUND,
  // color: "white",
  // fontWeight: "bold",
});
const Td = styled("td")({
  border: "1px solid darkgray",
  width: "20px",
  fontSize: "0.7rem",
  textAlign: "center",
});
const Tdd = styled("td")({
  border: "1px solid darkgray",
  width: "20px",
  fontSize: "0.7rem",
  textAlign: "center",
  background: "#f1f3f4",
});
// user row
const Tdu = styled("td")({
  border: "1px solid darkgray",
  fontSize: "0.7rem",
  textAlign: "center",
  background: "#ebfcff",
});
// user name colume in user row
const Tdnu = styled("td")({
  border: "1px solid darkgray",
  // width: "130px",
  fontSize: "0.7rem",
  padding: "1px 5px",
  background: "#ebfcff",
});
// user name column
const Tdn = styled("td")({
  border: "1px solid darkgray",
  // width: "130px",
  padding: "1px 5px",
  fontSize: "0.7rem",
});
const Table = styled("table")({
  marginTop: "10px",
  borderCollapse: "collapse",
});
